import styled from 'styled-components';

import Card from '../../Card';


export const StyledCard = styled(Card)`

  h5 {
    text-align: center;
  }

  .nivocontainer {
    width: 100%;
    height: 360px;

    g text {
      fill: white !important;
    }
  }

  button, .button:focus {
    width: 50%;
    outline: none;
    margin: 20px 25% 10px;
  }

  @media all and (max-width: 768px) {
    width: 100%;
    h2.title {
      font-size: 22px;
    }
  }
  @media all and (min-width: 993px) and (max-width: 1200px) {
    width: 100%;h2.title {
  font-size: 22px;
}
   }`;



// WEBPACK FOOTER //
// ./src/components/DataCentre/PerformanceGraph/PerformanceGraph.styles.ts